import { Urls } from '../../../Shared/Api';

export default class ReviewsCarouselService {
    static getReviews() {
        return fetch(Urls.reviews.getData)
            .then((res) => {
                return res.json();
            });
    }
}


// WEBPACK FOOTER //
// ./Src/Components/Reviews/ReviewsCarousel/ReviewsCarouselService.js